import { maybeRenderInPortal, useClickOnMask } from '@/utils'
import { ReactElement, cloneElement } from 'react'
import { Mask } from '../styled'

interface Props {
  absolute?: boolean
  isOpen: boolean
  children: ReactElement
  closable?: boolean
  onClose?: () => void
  shouldRenderInPortal?: boolean
  noAnimation?: boolean
}

export const WithMask = ({
  absolute,
  isOpen,
  children,
  closable,
  onClose,
  shouldRenderInPortal = true,
  noAnimation,
}: Props) => {
  const handleMaskClick = () => {
    if (closable && onClose) onClose()
  }

  useClickOnMask(handleMaskClick)

  if (!isOpen) return null

  return maybeRenderInPortal(
    <Mask absolute={absolute} className="modal-mask" noAnimation={noAnimation}>
      {cloneElement(children)}
    </Mask>,
    document.body,
    shouldRenderInPortal,
  )
}
